module.exports = function getResource(label, vars = []) {
    let resources = {
        recentActivityText: 'Activité récente',
        viewAllActivityLink: 'Voir toute l’activité',
        spendLabel: 'Dépensez',
        earnedLabel: 'Gagnés',
        spendText: 'Dépensez'
    };

    return resources[label];
};
